import { Link } from "react-router-dom";
import authentication from '../authentication/b2c';
import { useEffect, useState } from "react";
import Api from "../api/api";
import roleUtilities from "../../utilities/roleUtilities";
import arrayUtilities from "../../utilities/arrayUtilities";

function ClientPortalHeader(props) {
    const [allowedBreachesView, setAllowedBreachesView] = useState(false)
    useEffect(() => {
        Api.getBreaches(
            data => setAllowedBreachesView(data.status !== 401 && roleUtilities.isClientManager(props.user, props.organisationId)),
            error => console.log(error),
            null, null, null, null, null, null, null, null, null, 0, 0, null, null, null,
            null, null,
            null,
            props.organisationId,
            props.token
        )
    }, [])

    return (
        <>
        <nav className="navbar navbar-light navbar-glass navbar-top sticky-kit navbar-expand-lg">
            <button className="btn navbar-toggler-humburger-icon navbar-toggler mr-1 mr-sm-3" type="button" data-toggle="collapse" data-target="#navbarStandard" aria-controls="navbarStandard" aria-expanded="false" aria-label="Toggle Navigation"><span className="navbar-toggle-icon"><span className="toggle-line"></span></span></button>
            <a className="navbar-brand mr-1 mr-sm-3" href="/">
                <div className="d-flex align-items-center"><img className="mr-2" src="/assets/img/apt-logos/logo.svg" alt="" width="100" />
                </div>
            </a>
            <div className="collapse navbar-collapse" id="navbarStandard">
                <ul className="navbar-nav">
                    <li className="nav-item"><Link to="/" className="nav-link" role="button">Allow List</Link></li>
                    <li className="nav-item"><Link to="/disallow-list" className="nav-link" role="button">Disallow List</Link></li>
                    {
                    allowedBreachesView &&
                    <li className="nav-item"><Link to="/breaches" className="nav-link" role="button">Breaches</Link></li>
                }
                    {
                        !arrayUtilities.isNullOrEmpty(props.permittedReports) &&
                        <li className="nav-item"><Link to={`/organisation/${props.organisationId}/reports`} className="nav-link" role="button">Reports</Link></li>
                    }
                    {
                        props.showPaymentsScreen &&
                        <li className="nav-item"><Link to={`/organisation/${props.organisationId}/raw-data/payments`} className="nav-link" role="button">Payments</Link></li>
                    }
                    {
                        props.showVehicleAnalyticsScreen &&
                        <li className="nav-item"><Link to={`/organisation/${props.organisationId}/vehicle-analytics`} className="nav-link" role="button">Vehicle Analytics</Link></li>
                    }
                </ul>
            </div>
            <ul className="navbar-nav navbar-nav-icons ml-auto flex-row align-items-center">
                <li className="nav-item dropdown dropdown-on-hover">
                    <a className="nav-link pr-0 user-icon" id="navbarDropdownUser" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {props.user !== null && props.user !== undefined &&
                            <>
                                {props.user.firstName[0]}{props.user.lastName[0]}
                            </>}
                    </a>
                    <div className="dropdown-menu dropdown-menu-right py-0" aria-labelledby="navbarDropdownUser">
                        <div className="bg-white rounded-soft py-2">
                            {props.user !== undefined && props.user.organisations.length > 1 &&
                                <>
                                    <a className="dropdown-item" href="/">Select Organisation</a>
                                    <div className="dropdown-divider"></div>
                                </>}
                                <button type="button" className="dropdown-item" data-toggle="modal" data-target="#signOutModal">Sign Out</button>
                        </div>
                    </div>
                </li>
            </ul>
        </nav>
                  <div className="modal fade" id="signOutModal" tabIndex="-1" role="dialog" aria-labelledby="signOutModalLabel" aria-hidden="true">
                  <div className="modal-dialog" role="document">
                      <div className="modal-content">
                          <div className="modal-header">
                              <h5 className="modal-title" id="signOutModalLabel">Are you sure you want to Sign Out?</h5>
                              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                  <span aria-hidden="true">&times;</span>
                              </button>
                          </div>
                          <div className="modal-footer">
                              <button type="button" className="btn btn-falcon-default btn-sm ml-2" data-dismiss="modal">Cancel</button>
                              <button className="btn btn-primary btn-sm" data-dismiss="modal" onClick={() => {
                                Api.userLogout(
                                    null,
                                    error => console.log(error),
                                    props.organisationId, props.token
                                )
                                authentication.signOut()
                              }}>Sign Out</button>
                          </div>
                      </div>
                  </div>
              </div>
          </>
    )
}
export default ClientPortalHeader;